import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormTabPaneProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IFormTabPaneProps>>
): IComponentSchema<IFormTabPaneProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FormTabPane,
    'x-component-props': {
      tab: props?.['x-component-props']?.tab || 'New Tab',
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    properties: props?.properties || {},
  };
};
